//
// IMPORTS
//

// Branding por parceiro (logo e título do card de autenticação)
import { logo, authTitle } from './partnerBranding'

// Firebase environment settings
import firebaseSettingsObject from './firebaseSettings'

// Base URLs for the API
import apiUrl from './apiUrl'
import reportUrl from './reportUrl'
import cloudFunctionsUrl from './cloudFunctionsUrl'

// Environment settings
import freeVersion from './freeVersion'
import whiteLabel from './whiteLabel'
import version from './version'

// Countries on the PAYMENT screen (PaymentModal.vue)
import countries from './countries'

// User roles
import { MASTER_USER_ROLE, MANAGER_USER_ROLE, MEMBER_USER_ROLE, USER_ROLES } from './userRoles'

// User capabilities
import {
  GRUPO_ALTERAR_DETALHES_DA_ESCALA, GRUPO_EDITAR_DETALHES, GRUPO_CONVIDAR_USUARIO, GRUPO_NOVA_ESCALA, GRUPO_GERAR_FOLHA_DE_PONTO, GRUPO_SIMULAR_FOLHA_DE_PONTO, GRUPO_FOLHA_DE_PAGAMENTO, GRUPO_VER_TODOS_OS_PLANTOES, GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA,

  ESCALA_APAGAR, ESCALA_RENOVAR_LINK, ESCALA_COMPARTILHAR, ESCALA_RETIRAR_USUARIO, ESCALA_ALTERAR_PAPEL, ESCALA_VER_PLANTOES_DO_USUARIO, ESCALA_DISPARAR_PLANTOES,

  DETALHES_PLANTAO_NOVO_PLANTAO, DETALHES_PLANTAO_VER, DETALHES_PLANTAO_APAGAR, DETALHES_PLANTAO_DIVIDIR, DETALHES_PLANTAO_ALTERAR, DETALHES_PLANTAO_PERSONALIZAR_REGISTRO,

  USER_CAPABILITIES,EXPORT_OPERATIONAL_REPORT, GRUPO_VER_USUARIOS, GRUPO_VER_VALORES
} from './userCapabilities'

//
// CONFIGURAÇÃO FORA DO .ENV PARA EVITAR RETRABALHO (Nota em 20 Feb 1:45 AM)
//

const PARTNER = process.env.VUE_APP_PARTNER || "DEFAULT"

//
// EXPORTS
//

export {
  // Environment logo
  logo,
  authTitle,

  // Firebase environment settings
  firebaseSettingsObject,

  // Base URLs for the API
  apiUrl,
  reportUrl,
  cloudFunctionsUrl,

  // Environment settings
  freeVersion,
  whiteLabel,
  version,

  // Countries on the PAYMENT screen (PaymentModal.vue)
  countries,

  // User roles
  MASTER_USER_ROLE, MANAGER_USER_ROLE, MEMBER_USER_ROLE, USER_ROLES,

  // User capabilities
  GRUPO_ALTERAR_DETALHES_DA_ESCALA, GRUPO_EDITAR_DETALHES, GRUPO_CONVIDAR_USUARIO, GRUPO_NOVA_ESCALA, GRUPO_GERAR_FOLHA_DE_PONTO, GRUPO_SIMULAR_FOLHA_DE_PONTO, GRUPO_FOLHA_DE_PAGAMENTO, GRUPO_VER_TODOS_OS_PLANTOES, GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA,
  ESCALA_APAGAR, ESCALA_RENOVAR_LINK, ESCALA_COMPARTILHAR, ESCALA_RETIRAR_USUARIO, ESCALA_ALTERAR_PAPEL, ESCALA_VER_PLANTOES_DO_USUARIO, ESCALA_DISPARAR_PLANTOES,
  DETALHES_PLANTAO_NOVO_PLANTAO, DETALHES_PLANTAO_VER, DETALHES_PLANTAO_APAGAR, DETALHES_PLANTAO_DIVIDIR, DETALHES_PLANTAO_ALTERAR, DETALHES_PLANTAO_PERSONALIZAR_REGISTRO,
  USER_CAPABILITIES, EXPORT_OPERATIONAL_REPORT, GRUPO_VER_USUARIOS, GRUPO_VER_VALORES,

  // Se for white label, qual o parceiro SOS Plantão?
  PARTNER
}
